import * as types from './mutation-types';

const mutations = {
  [types.LANGUAGE](state, language) {
    state.language = language;
  },
};

export default mutations;
